import {isVirtualOffice} from '../../utils/reservationPresence';
import React, {useEffect, useRef, useState} from 'react';
import {ClipboardCheck, Clock3} from 'lucide-react';
import {fetchSesionesByCita, Sesion} from '../../services/sesionesService.ts';
import AsistenciaSesionModal from '../../pages/shared/AsistenciaSesionModal.tsx';
import {Cita} from '../../services/citasService.ts';
import CompactListDialog from './CompactListDialog';

type Props = {
  cita:Cita;
  fechaAsistencia?:string;
  onChanged?:()=>void;
  sessionId?:number;
  operatorToken?:string|null;
  revision?:number;
};

export default function AsistenciaReservaPanel({cita,fechaAsistencia,onChanged,sessionId,operatorToken,revision=0}:Props) {
  const [sesiones,setSesiones]=useState<Sesion[]>([]);
  const [loading,setLoading]=useState(true);
  const [error,setError]=useState('');
  const [verTodas,setVerTodas]=useState(false);
  const [seleccionada,setSeleccionada]=useState<number|null>(null);
  const source=useRef<number|null>(null);
  useEffect(()=>{
    if(isVirtualOffice(cita)){setLoading(false);setSesiones([]);return;}
    let active=true;
    if(source.current!==cita.id){source.current=cita.id;setSeleccionada(null);setVerTodas(false);setSesiones([]);setLoading(true);}
    setError('');fetchSesionesByCita(cita.id).then(data=>{if(active)setSesiones(data);})
      .catch(()=>{if(active)setError('No se pudieron actualizar las sesiones de esta reserva.');})
      .finally(()=>{if(active)setLoading(false);});
    return()=>{active=false;};
  },[cita.id,cita.servicio_info?.tipo_servicio,revision]);
  const activas=sesiones.filter(s=>(typeof s.cita==='object'?s.cita.id:s.cita)===cita.id&&!s.archivada&&(!fechaAsistencia||(s.fecha_inicio<=fechaAsistencia&&s.fecha_fin>=fechaAsistencia)));
  const selected=sesiones.find(s=>s.id===seleccionada);
  const renderSesion=(s:Sesion)=><div key={s.id} className="att-panel-row"><strong>{s.fecha_inicio===s.fecha_fin?s.fecha_inicio:`${s.fecha_inicio} – ${s.fecha_fin}`}</strong><p>Horario: {s.hora_inicio?.slice(0,5)||'—'} – {s.hora_fin?.slice(0,5)||'Abierto'}</p><button className="att-button" onClick={()=>{setVerTodas(false);setSeleccionada(s.id);}}><Clock3 size={14}/>Ver ingreso/salida</button></div>;
  if(isVirtualOffice(cita)) return null;
  return <section className="att-panel">
    <div className="att-panel-heading"><ClipboardCheck size={19}/><div><h3>Asistencia y horas reales</h3><small>Control de ingreso, salida y tiempo utilizado</small></div></div>
    <div className="att-panel-content">{loading?<p role="status">Cargando sesiones…</p>:error&&!activas.length?<p role="alert">{error}</p>:!activas.length?<p>{fechaAsistencia?'No hay sesiones de esta reserva para la fecha seleccionada.':'Esta reserva aún no tiene sesiones activas.'}</p>:<>{activas.slice(0,2).map(renderSesion)}{activas.length>2&&<button className="att-button cw-show-more" onClick={()=>setVerTodas(true)}>Ver todas (+{activas.length-2})</button>}</>}</div>
    {error&&activas.length>0&&<p className="rw-error" role="alert">{error}</p>}
    {verTodas&&<CompactListDialog title={`Sesiones de asistencia (${activas.length})`} onClose={()=>setVerTodas(false)}><div className="cw-session-list">{activas.map(renderSesion)}</div></CompactListDialog>}
    {selected&&<AsistenciaSesionModal sesionId={selected.id} modoPersonal fechaAsistencia={fechaAsistencia} reglasReserva={cita.reglas_plan_reserva} horarioReservado={{inicio:selected.hora_inicio,fin:selected.hora_fin}} timerArrival={sessionId&&cita.temporizador_info&&cita.temporizador_info.llegada_confirmada===false?{sessionId,operatorToken:operatorToken||null,legacy:!!cita.temporizador_info.llegada_real}:undefined} onClose={()=>{setSeleccionada(null);onChanged?.();}}/>}
  </section>;
}

